module.exports = __webpack_public_path__ + "img/help.60bdbf83.svg";